import { createRouter, createWebHistory } from "vue-router";

// Import your components
import HomeView from "../views/HomeView.vue";
import NotFound from "../views/NotFoundPage.vue";

// Define routes
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeView
    },
    {
      path: "/:pathMatch(.*)*",
      component: NotFound,
    },
  ],
});

// Create the router instance
export default router;
